import React from "react";
import PropTypes from "prop-types";
import BookingBookableProfileLinks from "../BookingBookableProfileLinks/BookingBookableProfileLinks";
import useFunction from "../../hooks/useFunction";
import useBooking from "../../hooks/useBooking";
import Button from "../Button/Button";
// import "./style.scss";

const BookingItemPreview = ({booking}) => {
  const {date} = useFunction();
  const {getBookingStatusLabel, getBookingActionLabel, getBookingStatusIcon} = useBooking();
  const getImageSource = (booking) => {
    if (booking.type === 'spot-group-requests-stand' && booking.direction === 'requesting') {
      return booking.stand?.overview_media?.path?.absolute_url_thumb
    } else {
      return booking.spot_group?.overview_media?.path?.absolute_url_thumb
    }
  }

  return (
    <div
      className={`component-booking-item-preview booking-status-${booking.status}${booking.needs_action ? ' needs-action' : ''}`}
    >
      <div className="image">
        <img src={getImageSource(booking)} alt=""/>
      </div>
      <div className="col-mid">
        <div className="status">
          <h4><span
            className="dot"><img src={getBookingStatusIcon(booking)} alt=""/></span>{getBookingStatusLabel(booking.status)} {booking.needs_action ? " - " + getBookingActionLabel(booking.needs_action) : ""}
          </h4>
        </div>
        <div className="bookables">
          <BookingBookableProfileLinks
            booking={booking}
            buttonSize={"xs"}
          />
        </div>
      </div>

      <div className="col-right">
        <Button
          label="Bekijk"
          link={"/user/boeking/" + booking.id}
          size={"s"}
          // color="grey-ghost"
          color="green"
        />

        <div className="meta">
          <>
            {booking.date_ranges.slice(0, 3).map((dateRange, i) => (
              <p key={i}>
                {dateRange.end_date ? (
                  <>{date(dateRange.start_date)} <span className="tm">t/m</span> {date(dateRange.end_date)}</>
                ) : (
                  <>{date(dateRange.start_date)}</>
                )}
              </p>
            ))}
            {booking.date_ranges.length > 3 && <p>...</p>}
          </>
          <p className="booking-number">#{booking.booking_number}</p>
        </div>
      </div>
    </div>
  );
};

BookingItemPreview.propTypes = {
  booking: PropTypes.object.isRequired,
};

export default BookingItemPreview;
